import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button, ButtonType } from '@/components/atoms/button'
import { EditFooter } from '@/components/organisms/edit-footer'

type Props = {
  isDirty: boolean
  onCancel: () => void
  onSave: () => void
  onTest: () => void
  isTestDisabled: boolean
}

export const DeviceSettingsFooter: React.FC<Props> = ({ isDirty, onCancel, onSave, onTest, isTestDisabled }) => {
  const { t } = useTranslation()

  // 保存前の値で接続しても意味がないため、編集中は接続テストを出さず保存・キャンセルに切り替える
  if (isDirty) {
    return <EditFooter onCancel={onCancel} onSave={onSave} />
  }

  return (
    <Button
      buttonType={isTestDisabled ? ButtonType.BorderDisabled : ButtonType.Secondary}
      isDisabled={isTestDisabled}
      width={110}
      height={38}
      fontSize={14}
      marginLeft={32}
      marginTop={11}
      marginBottom={11}
      onClick={onTest}
    >
      {t('Connection test')}
    </Button>
  )
}
